// src/components/modals/EditCommentModal.tsx
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";
import '../Pages/Tasks/Task.css';

interface EditCommentModalProps {
  isOpen: boolean;
  toggle: () => void;
  comment: string;
  setComment: (text: string) => void;
  onConfirm: () => void;
}

const EditCommentModal: React.FC<EditCommentModalProps> = ({
  isOpen, toggle, comment, setComment, onConfirm
}) => (
  <Modal isOpen={isOpen} toggle={toggle}   className={`${
    localStorage.getItem("mode") ? localStorage.getItem("mode") : "light"
  }`}>
    <ModalHeader className="modal-header-style theme-text-color d-flex align-items-center justify-content-center">Editar Comentário</ModalHeader>
    <ModalBody className="modal-body-style">
      <Input
        type="textarea"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        rows={8}
        className="input-modal theme-text-color"
      />
    </ModalBody>
    <ModalFooter className="modal-footer-style d-flex align-items-center justify-content-end">
      <Button color="primary" onClick={onConfirm} id="btn-edit-comment">Confirmar</Button>
      <Button color="secondary" onClick={toggle}>Cancelar</Button>
    </ModalFooter>
  </Modal>
);

export default EditCommentModal;
